window._laboteca_menumovil_interval = setInterval(function(){
    if ( !document.getElementById('menuMobile') || !document.getElementById('menuMobile').querySelector('.mobile-sub-menu .menu_list-item.dropdown.dropdown-submenu') ) {
        return false;
    }
    document.querySelectorAll('.mobile-sub-menu .menu_list-item.dropdown.dropdown-submenu').forEach(function(a){
        a.addEventListener('click', function(){
            this.classList.toggle('expanded');
        });
    });
    clearInterval( window._laboteca_menumovil_interval );
    window._laboteca_menumovil_interval = null;
    return true;
}, 1000);